// pl_pms_night_audit.ts
// Tłumaczenia dla PMS.NightAudit.tsx

export const plPmsNightAudit = {

  title: "Night Audit",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomTaxPosting:      "Podatki pokojowe",
    openBalances:        "Otwarte salda",
    noShowHandling:      "Niestawienia",
    overstayExceptions:  "Wyjątki pobytu",
    rateIntegrity:       "Stawki",
    housekeepingSummary: "Housekeeping",
    finalControl:        "Kontrola finalna",
  },

  // ── Przyciski ─────────────────────────────────────────────────────────────
  actions: {
    closeDay:      "Zamknij dzień",
    closing:       "Zamykanie...",
    opening:       "Otwieranie...",
    createInvoice: "Utwórz fakturę",
    creating:      "Tworzenie...",
    downloadPDF:   "Pobierz PDF",
    previewPDF:    "Podgląd PDF",
    saving:        "Zapisywanie...",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    invoice:          "Faktura",
    fiscalizedInvoice:"Faktura fiskalna",
    nightAuditFolio:  "Karta Night Audit",
    noFolioSelected:  "Nie wybrano karty",
    rateOutlier:      "Wartość odstająca",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    invoiceFailed: "Generowanie faktury nie powiodło się",
  },

} as const;

export default plPmsNightAudit;
